<template>
    <!-- User Profile Health Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock">
            <div class="row" v-if="ajax_call_in_progress">
                <div class="col-lg-12 py-5 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col-lg-12">
                    <div class="ml-2 mr-1 mb-3">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader pb-4 health-view">
                                    <div class="a-q-Jc-j-contactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Blood Group</div>
                                            <div class="d-flex align-items-center w-100">
                                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                                    <multiselect
                                                        v-model="health_data.blood_group"
                                                        @open="editValue('blood_group')"
                                                        :disabled="$route.params.id != loggedInUser.user_id"
                                                        openDirection="bottom"
                                                        class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                                        :options="['A+','A-','B+','B-','O+','O-','AB+','AB-']"
                                                        :multiple="false" :searchable="true" :internal-search="true"
                                                        :clear-on-select="false" :close-on-select="true"
                                                        :options-limit="280" :max-height="200" :show-no-results="true"
                                                        :hide-selected="false">
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">No Blood Groups Found</div>
                                                        </template>
                                                    </multiselect>
                                                </el-tooltip>
                                                <div v-if="edit_blood_group == true" class="d-flex justify-content-end align-items-center">
                                                    <div class="pointer" @click="resetValue('blood_group')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="addUpdateHealth('blood_group')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                Pre-Existing Conditions
                                                <sup class="fs-14 mandatory">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="d-flex align-items-center w-100" style="padding-top:15px;">
                                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                                    <multiselect
                                                        v-model="health_data.pre_existing_conditions"
                                                        @open="dropdownsData('pre-existing_conditions')"
                                                        @remove="removeConditionsChip"
                                                        openDirection="bottom"
                                                        :disabled="$route.params.id != loggedInUser.user_id"
                                                        :loading="dropdown_loading"
                                                        class="digi-multiselect approval-manager filter-multiple"
                                                        :options="pre_existing_conditions_options"
                                                        :multiple="true" :searchable="true" :internal-search="true"
                                                        :clear-on-select="false" :close-on-select="true"
                                                        @close="closeConditionsDropdowns(health_data.pre_existing_conditions, 'pre_existing_conditions')"
                                                        :options-limit="200" :max-height="250"
                                                        :show-no-results="true" :hide-selected="false">
                                                        <template slot="tag" slot-scope="{ option }">
                                                            <span class="custom__tag">
                                                                <span class="filterSelectedName"
                                                                    style="display:contents;">{{ option }}</span>
                                                                    <i aria-hidden="true" @click="removeConditionsChip(option)" tabindex="1" class="icon icon-close fs-16 text-white custom__remove pointer"></i>
                                                            </span>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">No Conditions Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-if="!dropdown_loading" class="add-vendor p-2 pointer fw-500">
                                                                Add Pre-Existing Conditions <span class="text-secondary fw-500">'{{"-"}}'</span>
                                                                <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                            </div>
                                                        </template>
                                                    </multiselect>
                                                </el-tooltip>
                                                <div v-if="edit_pre_existing_conditions == true" class="d-flex justify-content-end align-items-center">
                                                    <div class="pointer" @click="resetValue('pre_existing_conditions')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="addUpdateHealth('pre_existing_conditions')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-6">
                                        <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                Allergies
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="d-flex align-items-center w-100" style="padding-top:15px;">
                                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                                    <multiselect v-model="health_data.allergies"
                                                        @open="dropdownsData('allergies')"
                                                        @remove="removeAllergiesChip"
                                                        class="digi-multiselect approval-manager filter-multiple"
                                                        :loading="dropdown_loading"
                                                        openDirection="bottom"
                                                        :disabled="$route.params.id != loggedInUser.user_id"
                                                        :options="allergies_options"
                                                        :multiple="true" :searchable="true" :internal-search="true"
                                                        :clear-on-select="false" :close-on-select="true"
                                                        @close="closeConditionsDropdowns(health_data.allergies, 'allergies')"
                                                        :options-limit="200" :max-height="1000"
                                                        :show-no-results="true" :hide-selected="false">
                                                        <template slot="tag" slot-scope="{ option }">
                                                            <span class="custom__tag">
                                                                <span class="filterSelectedName"
                                                                    style="display:contents;">{{ option }}</span>
                                                                    <i aria-hidden="true" @click="removeAllergiesChip(option)" tabindex="1" class="icon icon-close fs-16 text-white custom__remove pointer"></i>
                                                            </span>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No
                                                                Results Found</div>
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">No Allergies Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-if="!dropdown_loading" class="add-vendor p-2 pointer fw-500">
                                                                Add Allergies <span class="text-secondary fw-500">'{{"-"}}'</span>
                                                                <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                            </div>
                                                        </template>
                                                    </multiselect>
                                                </el-tooltip>
                                                <div v-if="edit_allergies == true" class="d-flex justify-content-end align-items-center">
                                                    <div class="pointer" @click="resetValue('allergies')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="addUpdateHealth('allergies')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-6">
                                        <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">
                                                Medications
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="d-flex align-items-center w-100" style="padding-top:15px;">
                                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                                    <multiselect v-model="health_data.medications"
                                                        @open="dropdownsData('medications')"
                                                        :loading="dropdown_loading"
                                                        @remove="removeMedicationsChip"
                                                        class="digi-multiselect approval-manager filter-multiple"
                                                        :disabled="$route.params.id != loggedInUser.user_id"
                                                        openDirection="bottom"
                                                        :options="medications_options"
                                                        :multiple="true" :searchable="true" :internal-search="true"
                                                        :clear-on-select="false" :close-on-select="true"
                                                        :options-limit="200" :max-height="1000"
                                                        @close="closeConditionsDropdowns(health_data.medications, 'medications')"
                                                        :show-no-results="true" :hide-selected="false">
                                                        <template slot="tag" slot-scope="{ option }">
                                                            <span class="custom__tag">
                                                                <span class="filterSelectedName"
                                                                    style="display:contents">{{ option }}</span>
                                                                    <i aria-hidden="true" @click="removeMedicationsChip(option)" tabindex="1" class="icon icon-close fs-16 text-white custom__remove pointer"></i>
                                                            </span>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">No Medications Found</div>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-if="!dropdown_loading" class="add-vendor p-2 pointer fw-500">
                                                                Add Medications <span class="text-secondary fw-500">'{{"-"}}'</span>
                                                                <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                            </div>
                                                        </template>
                                                    </multiselect>
                                                </el-tooltip>
                                                <div v-if="edit_medications == true" class="d-flex justify-content-end align-items-center">
                                                    <div class="pointer" @click="resetValue('medications')">
                                                        <img src="/static/images/check.svg">
                                                    </div>
                                                    <div class="ml-2 pointer" @click="addUpdateHealth('medications')">
                                                        <img src="/static/images/close.svg">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView mt-6">
                                        <div class="a-q-Jc-Pj-Ya-contactView">
                                            <div class="a-q-Jc-bj-contactView defaultBlue">Medical Emergency Notes</div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-contactView">
                                        <div class="a-q-Jc-Pj-Ya-contactView" style="position: relative;">
                                            <div class="d-flex justify-content-end align-items-center"
                                                v-if="edit_notes" style="position: absolute;top:5px;right:20px;">
                                                <div class="pointer" @click="resetValue('notes')">
                                                    <img src="/static/images/check.svg">
                                                </div>
                                                <div class="ml-2 pointer" @click="addUpdateHealth('notes')">
                                                    <img src="/static/images/close.svg">
                                                </div>
                                            </div>
                                            <!-- <textarea v-model="userData.notes" disabled style="width: 100%; background: transparent; color: #303031; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.16); resize: none; height: 8em; padding: 0px 10px 20px 10px; overflow-y: auto"></textarea> -->
                                            <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">

                                                <textarea v-model="health_data.notes"
                                                    @focus="editValue('notes')"
                                                    :readonly="!edit_notes" maxlength="1000"
                                                    style="padding-top: 6px !important; width: 100%; background: transparent; color: #303031; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.16); resize: none; height: 8em; padding: 0px 10px 20px 10px; overflow-y: auto;padding-right: 75px !important;">
                                                </textarea>
                                            </el-tooltip>
                                            <div style="position: absolute;bottom: 0;right:20px;" class="text-right text-grey"
                                            ><span>{{health_data.notes.length}}/1000</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import profile from "./mixins/profile";
    export default {
        props: [],
        mixins: [profile],
        components: {
            HalfCircleSpinner
        },
        data() {
            return {
                ajax_call_in_progress: false,
                edit_blood_group: false,
                edit_notes: false,
                edit_pre_existing_conditions: false,
                edit_allergies: false,
                edit_medications: false,
                edit_user_data: [],
                blood_group_options: [],
                pre_existing_conditions_options: [],
                dropdown_loading: false,
                allergies_options: [],
                medications_options: [],
                pre_existing_conditions: [],
                allergies: [],
                medications: [],
                user_data: {},
                // address_types: ['Office', 'Factory', 'Others']
                health_data: {
                    allergies: [""],
                    blood_group: "",
                    medications: [""],
                    notes: "",
                    pre_existing_conditions: [""],
                }
            }
        },
        methods: {
            editValue(obj) {
                if(this.$route.params.id == this.loggedInUser.user_id) {
                    if (obj == 'blood_group') {
                        this.edit_blood_group = true;
                        this.edit_notes = false;
                        this.edit_pre_existing_conditions = false;
                        this.edit_allergies = false;
                        this.edit_medications = false;
                    } else if (obj == 'notes') {
                        this.edit_blood_group = false;
                        this.edit_notes = true;
                        this.edit_pre_existing_conditions = false;
                        this.edit_allergies = false;
                        this.edit_medications = false;
                    } else if (obj == 'pre_existing_conditions') {
                        this.edit_blood_group = false;
                        this.edit_notes = false;
                        this.edit_pre_existing_conditions = true;
                        this.edit_allergies = false;
                        this.edit_medications = false;
                    } else if (obj == 'allergies') {
                        this.edit_blood_group = false;
                        this.edit_notes = false;
                        this.edit_pre_existing_conditions = false;
                        this.edit_allergies = true;
                        this.edit_medications = false;
                    } else if (obj == 'medications') {
                        this.edit_blood_group = false;
                        this.edit_notes = false;
                        this.edit_pre_existing_conditions = false;
                        this.edit_allergies = false;
                        this.edit_medications = true;
                    }
                }
            },
            resetValue(obj) {
                let user_data = JSON.parse(localStorage.getItem('health_data_store'));
                if (obj == 'blood_group') {
                    this.edit_blood_group = false;
                    this.health_data.blood_group = user_data.blood_group == undefined || null ? '' : user_data.blood_group
                } else if (obj == 'notes') {
                    this.edit_notes = false;
                    this.health_data.notes = user_data.notes == undefined || null ? '' : user_data.notes;
                } else if (obj == 'pre_existing_conditions') {
                    this.edit_pre_existing_conditions = false;
                    this.health_data.pre_existing_conditions = user_data.pre_existing_conditions == undefined || null ? '' : user_data.pre_existing_conditions;
                } else if (obj == 'allergies') {
                    this.edit_allergies = false;
                    this.health_data.allergies = user_data.allergies == undefined || null ? '' : user_data.allergies;
                } else if (obj == 'medications') {
                    this.edit_medications = false;
                    this.health_data.medications = user_data.medications == undefined || null ? '' : user_data.medications;
                }
            },
            removeConditionsChip(option) {
                this.pre_existing_conditions.forEach((el, index) => {
                    if (el == option) {
                        this.pre_existing_conditions.splice(index, 1)
                    }
                })
            },
            removeAllergiesChip(option) {
                this.health_data.allergies.forEach((el, index) => {
                    if (el == option) {
                        this.health_data.allergies.splice(index, 1)
                    }
                })
            },
            removeMedicationsChip(option) {
                this.health_data.medications.forEach((el, index) => {
                    if (el == option) {
                        this.health_data.medications.splice(index, 1)
                    }
                })
            },
            closeConditionsDropdowns(data, type) {
                if(type == 'pre_existing_conditions') {
                    this.pre_existing_conditions = data;
                } else if(type == 'allergies') {
                    this.allergies = data;
                } else if(type == 'medications') {
                    this.medications = data;
                }
            },
            async getHealthData() {
                this.ajax_call_in_progress = true;
                try {
                    let param = this.$route.params.id ? this.$route.params.id : this.loggedInUser.user_id;
                    let response = await this.getHealthInfo(param);
                    if(response.status_id == 1) {
                        localStorage.setItem('health_data_store', JSON.stringify(response.response));
                        this.edit_blood_group = false;
                        this.edit_notes = false;
                        this.edit_pre_existing_conditions = false;
                        this.edit_allergies = false;
                        this.edit_medications = false;
                        this.user_data = response.response;
                        if(Object.keys(this.user_data).length == 0) {
                            this.user_data = {
                                allergies: [],
                                blood_group: "",
                                medications: [],
                                notes: "",
                                pre_existing_conditions: [],
                            }
                        }
                        this.health_data = this.user_data;
                    }
                    this.ajax_call_in_progress = false;
                }
                catch(err) {
                    // console.log(err);
                }
            },
            async dropdownsData(type) {
                if(type == 'pre-existing_conditions') {
                    // this.edit_pre_existing_conditions = true;
                    this.editValue('pre_existing_conditions');
                }
                else if(type == 'allergies') {
                    // this.edit_allergies = true;
                    this.editValue('allergies');
                }
                else if(type == 'medications') {
                    // this.edit_medications = true;
                    this.editValue('medications');
                }
                this.dropdown_loading = true;
                try {
                    let params = type;
                    let response = await this.getDropdownsData(params);
                    if(response.status_id == 1) {
                        if(type == 'pre-existing_conditions') {
                            this.pre_existing_conditions_options = response.response;
                        }
                        else if(type == 'allergies') {
                            this.allergies_options = response.response;
                        }
                        else if(type == 'medications') {
                            this.medications_options = response.response;
                        }
                    }
                    this.dropdown_loading = false;
                }
                catch(err) {
                    // console.log(err);
                }
            },
            async addUpdateHealth(type) {
                try {
                    let params = {};
                    if(type == 'blood_group') {
                        params.blood_group = this.health_data.blood_group;
                    } else if(type == 'pre_existing_conditions') {
                        params.pre_existing_conditions = this.pre_existing_conditions;
                    } else if(type == 'allergies') {
                        params.allergies = this.allergies;
                    } else if(type == 'medications') {
                        params.medications = this.medications;
                    } else if(type == 'notes') {
                        params.notes = this.health_data.notes;
                    }
                    if(this.health_data.id) {
                        params.id = this.health_data.id;
                    }
                    let response = await this.updateHealthInfo(params, this.loggedInUser.user_id);
                    if(response.status_id == 1) {
                        this.getHealthData();
                    }
                }
                catch(err) {
                    // console.log(err);
                }
            }
        },
        mounted() {
            // console.log(this.userData);
            this.getHealthData();
        },
        created() {
            // localStorage.setItem("store_user_data", JSON.stringify(this.userData))
            // this.edit_user_data = JSON.parse(localStorage.getItem("store_user_data"))
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            // account() {
            //     return this.$store.getters.account;
            // },
            // selectedCompany() {
            //     return this.$store.getters.selectedCompany;
            // },
        },
    }
</script>

<style>
    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-firstblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-secondblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    textarea.textarea-control {
        height: auto;
    }

    textarea.textarea-control {
        display: block;
        width: 100%;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #4e5764;
        background-color: #fff;
        background-image: none;
        border: 1px solid #cdd2da;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        -webkit-transition: border-color ease-in-out 0.15s,
            box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        -webkit-transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
    }

    .input-group.digi-input-group {
        border: 1px solid #cdd2da !important;
    }

    .input-group.digi-input-group>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 22px !important;
        padding: 6px 12px 6px 2px !important;
        color: #4e5764;
        text-decoration: underline;
        border-bottom: 1px solid transparent !important;
    }

    .input-group.digi-input-group .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid transparent !important;
        padding-top: 2px;
        cursor: pointer;
    }

    .qrcode-block-view-account {
        border-radius: 6px;
        width: 104px;
        height: 105px;
        position: relative;
        display: inline-block;
        display: block;
        border: 1px solid #00448b;
        background: #d6e2ef;
    }

    .qrcode-content-view-account {
        text-align: center;
        margin: 6px auto;
        background: #d6e2ef !important;
    }

    .qr-logo-view-account {
        position: absolute;
        margin-top: 40px;
        margin-left: 35px;
        width: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/HealthView.vue